import { useState } from "react";

export default function CreditReportInstructionsModal({ onClose }) {
  const [step, setStep] = useState(0);
  const ua = navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isAndroid = /android/.test(ua);
  const isMobile = isIOS || isAndroid;
  const isDesktop = !isMobile;

  const instructions = [
    (
      <div>
        <p>
          Start by clicking the link after these steps to go to annualcreditreport.com.
          This is a free, federally sponsored service allowing you to check your credit accounts for the three credit bureaus:
        </p>
        <ul className="list-disc ml-6 mt-2 text-left">
          <li>Equifax</li>
          <li>Experian</li>
          <li>TransUnion</li>
        </ul>
        <p>We need these reports to get accurate addresses for the debts we will be discharging</p>
      </div>
    ),
    (
        <div className="text-center">
          <p>
            Once at annualcreditreport.com, click on "Request your free credit reports." The button may look different depending on whether you're using mobile or desktop.
          </p>
          <img
            src="/images/credit-instructions/step2-desktop.png"
            alt="Where to click on annualcreditreport.com"
            className="mt-4 rounded shadow max-w-full mx-auto"
          />
        </div>
      ),
    "Fill out your personal information as required. Ensure it matches your legal identity exactly. You may have to repeat this page for each report",
    "Choose all three reports (Equifax, Experian, and TransUnion) to get the most complete view. Follow the identity verification steps for each report as you get them.",
    "For each report you MUST print them to a PDF for uploading. To print as a PDF study the instructions in the image below. For transunion scale down to 80%",
    "Save these files to your phone or computer so you may upload it here."
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
        >
          ✕
        </button>

        <div className="mb-4">
          <h2 className="text-xl font-semibold text-indigo-700 mb-1">
            Step {step + 1} of {instructions.length}
          </h2>
          <p className="text-sm text-gray-500">
            Follow these instructions carefully to obtain your credit report.
          </p>
        </div>

        <div className="w-full bg-gray-200 h-2 rounded mb-4 overflow-hidden">
          <div
            className="h-2 bg-indigo-500 transition-all duration-500"
            style={{ width: `${((step + 1) / instructions.length) * 100}%` }}
          ></div>
        </div>

        <div
          key={step}
          className="mb-4 text-gray-800 transition-opacity duration-300 ease-in-out"
        >
          {instructions[step]}
        </div>

        <div className="flex justify-between items-center mt-6">
          <button
            onClick={() => setStep((prev) => prev - 1)}
            disabled={step === 0}
            className={`text-sm px-4 py-2 rounded ${
              step === 0
                ? "text-gray-300 cursor-not-allowed"
                : "text-indigo-600 hover:underline"
            }`}
          >
            ← Back
          </button>

          {step < instructions.length - 1 ? (
            <button
              onClick={() => setStep((prev) => prev + 1)}
              className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 text-sm"
            >
              Next →
            </button>
          ) : (
            <button
              onClick={onClose}
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 text-sm"
            >
              Got it!
            </button>
          )}
        </div>
      </div>
    </div>
  );
}